export const loanCalculationRuleSet = {
  SV: [
    {
      from: 10000,
      to: 29999,
      maxYears: 5,
    },
    {
      from: 30000,
      to: 49999,
      maxYears: 6,
    },
    {
      from: 50000,
      to: 69999,
      maxYears: 9,
    },
    {
      from: 70000,
      to: 99999,
      maxYears: 10,
    },
    {
      from: 100000,
      to: 349999,
      maxYears: 12,
    },
    {
      from: 350000,
      to: 500000,
      maxYears: 15,
    },
  ],
  NO: [
    {
      from: 10000,
      to: 29999,
      maxYears: 5,
    },
    {
      from: 30000,
      to: 49999,
      maxYears: 6,
    },
    {
      from: 50000,
      to: 69999,
      maxYears: 9,
    },
    {
      from: 70000,
      to: 99999,
      maxYears: 10,
    },
    {
      from: 100000,
      to: 349999,
      maxYears: 12,
    },
    {
      from: 350000,
      to: 500000,
      maxYears: 15,
    },
  ],
  DK: [
    {
      from: 10000,
      to: 29999,
      maxYears: 4,
    },
    {
      from: 30000,
      to: 49999,
      maxYears: 6,
    },
    {
      from: 50000,
      to: 69999,
      maxYears: 9,
    },
    {
      from: 70000,
      to: 99999,
      maxYears: 10,
    },
    {
      from: 100000,
      to: 349999,
      maxYears: 12,
    },
    {
      from: 350000,
      to: 500000,
      maxYears: 15,
    },
  ],
  FREE: [
    {
      from: 1,
      to: 99999999,
      maxYears: 30,
    },
  ],
};
